export class PasswordStrengthService {
    static calculateStrength(password) {
      if (!password) return 0
      
      let strength = 0
      if (password.length >= 8) strength++
      if (password.length >= 12) strength++
      if (/[A-Z]/.test(password) && /[a-z]/.test(password)) strength++
      if (/\d/.test(password)) strength++
      if (/[!@#$%^&*]/.test(password)) strength++
      
      return strength
    }
  
    static getStrengthColor(strength) {
      if (strength <= 1) return "bg-red-500"
      if (strength <= 3) return "bg-yellow-500"
      return "bg-green-500"
    }
  
    static getStrengthText(strength) {
      if (strength === 0) return ""
      if (strength <= 1) return "Weak"
      if (strength <= 3) return "Medium"
      return "Strong"
    }
  
    static getStrengthTextColor(strength) {
      if (strength <= 1) return 'text-red-600'
      if (strength <= 3) return 'text-yellow-600'
      return 'text-green-600'
    }
  }